module.exports = __webpack_public_path__ + "media/images/icn-close-018c664df62e6de9539783f9eabef64a.png";